import { formatPrintedAwb, normalizeAwb } from '@pelicargo/utils';

import { MatchTag } from './MatchTag';

type Props = {
  label: string;
  extractedAwb: string | null;
  quoteAwb: string | null;
};

/**
 * The extracted AWB checked against the one on the linked quote. Null (no tag) unless both sides hold a full AWB —
 * an absent value is not a mismatch.
 */
export const AwbMatchTag = ({ label, extractedAwb, quoteAwb }: Props) => {
  const extractedDigits = normalizeAwb(extractedAwb);
  const quoteDigits = normalizeAwb(quoteAwb);
  if (!extractedDigits || !quoteDigits) return null;

  const isMatch = extractedDigits === quoteDigits;
  const help = isMatch
    ? 'Matches the AWB on the quote'
    : `Does not match — the quote holds ${formatPrintedAwb(quoteAwb)}`;
  return <MatchTag isMatch={isMatch} help={help} label={label} />;
};
